import { ACTIONS, EVENTS } from 'react-joyride';
import { CustomStep } from './Tutorial';

export const settingsSteps = (): CustomStep[] => {
  const steps: CustomStep[] = [
    {
      content:
        'Easily add new users from your organization. We will send an invite to their email where they can create their account.',
      target: '#speeddial',
      disableBeacon: true,

      placement: 'auto',
      [ACTIONS.NEXT]: {
        [EVENTS.TARGET_NOT_FOUND]: 'openSettingsDrawer',
        [EVENTS.STEP_AFTER]: 'closeSettingsDrawer',
      },
      [ACTIONS.PREV]: {
        [EVENTS.TARGET_NOT_FOUND]: [['openSettingsDrawer', 'accountsTab'], 500],
        [EVENTS.STEP_AFTER]: 'closeSettingsDrawer',
      },
    },
    // {
    //   content: "Contacts will appear in the recipient list for messages you send through the Centerpiece platform.  ",
    //   target: '#table-array-add-contacts',
    //   disableBeacon: true,
    //   placement: 'auto',
    //   [ACTIONS.NEXT]: {
    //     [EVENTS.TARGET_NOT_FOUND]: "contactsTab",
    //     [EVENTS.STEP_AFTER]: "closeSettingsDrawer",
    //   },
    //   [ACTIONS.PREV]: {
    //     [EVENTS.TARGET_NOT_FOUND]: "openSettingsDrawer"
    //   }
    // },
  ];
  return steps;
};
